import {
  GET_PATIENT_PROFILE,
  RESET_PATIENT_PROFILE,
  GET_PATIENT_ORDERS,
  GET_ORDER_ROUTES,
  SHOW_ORDERS,
  RESET_PATIENT_ORDERS,
  PATIENT_PROFILE_RESET,
} from '../types/patient';
import { PayloadAction, RESET_STATE } from '../types/global';
// @ts-ignore
// eslint-disable-next-line import/extensions
import PatientResult from '../../generated/Result/Patient/PatientResult';

export interface PatientState {
  patientProfile: PatientResult,
  patientOrders: any[],
  showOrders: boolean,
}

const INITIAL_STATE: PatientState = {
  patientProfile: null,
  patientOrders: null,
  showOrders: null,
};

const patientReducer = function (state: PatientState = INITIAL_STATE, action: PayloadAction<any>): PatientState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case GET_PATIENT_PROFILE:
      return { ...state, patientProfile: action.payload };
    case RESET_PATIENT_PROFILE:
      return INITIAL_STATE;
    case SHOW_ORDERS:
      return { ...state, showOrders: action.payload };
    case GET_PATIENT_ORDERS:
      return { ...state, patientOrders: action.payload };
    case RESET_PATIENT_ORDERS:
      return { ...state, patientOrders: null };

      // TODO: Revisit the following - having some issues using this and
      // avoiding state mutations outside this reducer (issues lie in OrdersList).
    case GET_ORDER_ROUTES: {
      const { orderIdEncrypted, routes } = action.payload;
      const index = state.patientOrders.findIndex((o) => o.orderIdEncrypted === orderIdEncrypted);

      return {
        ...state,
        patientOrders: [
          ...state.patientOrders.slice(0, index),
          { ...state.patientOrders[index], routes },
          ...state.patientOrders.slice(index + 1),
        ],
      };
    }
    case PATIENT_PROFILE_RESET:
      return {
        ...state,
        patientProfile: null,
        patientOrders: null,
        showOrders: false
      };
    default:
      return state;
  }
};

export default patientReducer;
